import * as React from 'react';

export const PagesContext = React.createContext<object[]>([]);
